import { useEffect } from 'react';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import { useAppDispatch } from 'store/store';
import { setClientCobrand } from '../cobrandSlice';
import { useCobrand } from './useCobrandUtils';

export const useHandleCobrandChange = () => {
  const { cobrand } = useCobrand();

  const dispatch = useAppDispatch();
  const { setCobrandTheme } = useThemeUtils();

  useEffect(() => {
    // Update the client's cobrand in the Redux store and set the theme accordingly
    setCobrandTheme(cobrand.id);
    dispatch(setClientCobrand(cobrand.id));
  }, [cobrand.id, setCobrandTheme, dispatch]);
};
